import dayjs from 'dayjs'
import httpClient from '../api/httpClient'
import { server } from '../constants'
import { Aging } from '../constants/aging'

export function getDatesBetween(
  startDate: string | Date,
  endDate: string | Date,
  unit: dayjs.ManipulateType = 'day'
) {
  const dates = []
  let currentDate = dayjs(startDate)

  while (!currentDate.isAfter(endDate)) {
    dates.push(currentDate)
    currentDate = currentDate.add(1, unit)
  }
  return dates
}

export const checkSubmissionDelay = async (data: {
  paymentObjectives?: string
  receiptdate?: Date
}): Promise<boolean> => {
  if (!data.paymentObjectives || !data.receiptdate) {
    return false
  }

  let dayCount = 0
  const receiptdate = dayjs(data.receiptdate)
  const startDate = receiptdate.format('YYYY-MM-DD')

  const { data: holiday } = await httpClient.get(server.INFO + '/holiday', {
    params: { startDate }
  })
  if (!Array.isArray(holiday)) {
    throw new Error('Holiday is not Array type')
  }

  const endDate = dayjs().format('YYYY-MM-DD')
  const datesInRange = getDatesBetween(startDate, endDate)

  for (const date of datesInRange) {
    const isWeekend = [0, 6].includes(date.day())
    const currentDate = date.format('YYYY-MM-DD')
    if (!isWeekend && currentDate !== startDate) {
      const findHoliday = holiday.find(item => item.date === currentDate)
      if (!findHoliday) {
        dayCount++
      }
    }
  }

  const agingThresholds: Record<string, number> = {
    premium_NB: Aging.NB,
    premium_add_NB: Aging.NB,
    premium_renew: Aging.RENEW,
    premium_change: Aging.RENEW,
    premium_loan: Aging.RENEW,
    premium_extra: Aging.RENEW,
    premium_oth_fee: Aging.RENEW
  }

  const threshold = agingThresholds[data.paymentObjectives]

  return threshold !== undefined && dayCount > threshold
}
